<mat-card>
  <app-card-header
    [title]="'Derivar Alerta'"
    icono="forward"
    [botonCerrar]="true"
    (cerrar)="cancelar()"
  ></app-card-header>

  <form [formGroup]="form" (ngSubmit)="confirmar()" autocomplete="off">
    <mat-card-content class="card-content-crear">
      <!-- Tipo de derivación -->
      <section class="inputs-group">
        <div class="campo">
          <ng-select
            [items]="tiposDerivacion"
            bindValue="valor"
            bindLabel="etiqueta"
            formControlName="tipo"
            placeholder="Tipo de derivación"
            [clearable]="false"
            appendTo="body"
            notFoundText="Sin resultados"
            style="width: 100%"
          ></ng-select>
          <small class="ayuda">Seleccioná cómo se derivará la alerta</small>
        </div>
      </section>

      @if (form.get('tipo')?.value !== 'externa') {
        <section class="inputs-group">
          <ng-select
            [items]="centrosMonitoreo"
            bindValue="_id"
            bindLabel="nombre"
            formControlName="idCentroMonitoreo"
            placeholder="Centro de monitoreo"
            appendTo="body"
            notFoundText="Sin centros cargados"
            style="width: 100%"
          ></ng-select>
        </section>
      }

      @if (form.get('tipo')?.value === 'externa') {
        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>Entidad externa</mat-label>
            <input
              matInput
              formControlName="entidadExterna"
              [matAutocomplete]="autoEntidades"
              placeholder="Ej: Policía Local, Bomberos, etc."
            />
            <mat-autocomplete
              #autoEntidades="matAutocomplete"
              [displayWith]="displayEntidadExterna"
            >
              @if (entidadesExternasFiltradas.length === 0) {
                <mat-option disabled>
                  <em>Escribí para crear una nueva entidad</em>
                </mat-option>
              }
              @for (entidad of entidadesExternasFiltradas; track entidad) {
                <mat-option [value]="entidad">{{ entidad }}</mat-option>
              }
            </mat-autocomplete>
            <mat-hint>
              Seleccioná del histórico ({{ entidadesExternas.length }}
              entidades) o escriba una nueva
            </mat-hint>
          </mat-form-field>
        </section>
      }

      <!-- Avisos por tipo -->
      @if (form.get('tipo')?.value === 'normal') {
        <app-info-banner
          color="orange"
          icon="info"
          title="Derivación normal"
          message="Con derivación normal, la alerta desaparecerá de su vista y solo será visible en el centro derivado."
        ></app-info-banner>
      }

      @if (form.get('tipo')?.value === 'visibilidad-compartida') {
        <app-info-banner
          color="blue"
          icon="info"
          title="Visibilidad compartida"
          message="Con visibilidad compartida, tanto su centro como el centro derivado podrán ver y gestionar esta alerta."
        ></app-info-banner>
      }

      @if (form.get('tipo')?.value === 'externa') {
        <app-info-banner
          color="orange"
          icon="info"
          title="Derivación externa"
          message="La alerta se marcará como derivada externamente. Solo usted podrá gestionarla hasta que la entidad externa le comunique la resolución."
        ></app-info-banner>
      }
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <button irxBoton="secundario" type="button" (click)="cancelar()">
        Cancelar
      </button>
      <button
        irxBoton="principal"
        type="submit"
        [disabled]="form.invalid"
      >
        <mat-icon>forward</mat-icon>
        Derivar
      </button>
    </mat-card-actions>
  </form>
</mat-card>
